import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const StyledSpan = styled.span<{
  index: number;
}>`
  position: absolute;
  left: 0;
  align-self: ${(props) => {
    if (props.index % 2 === 1) {
      return 'flex-start';
    }
    if (props.index % 3 === 1) {
      return 'flex-end';
    }
    return 'center';
  }};
`;

export const StyledFloatingButton = styled(Link)`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  padding: 3px 14px 9px 15px;
  border-radius: 4px;
  font-family: var(--font-family-frutiger);
  color: var(--text-color-button);
  text-decoration: none;
  margin: 0;
  font-weight: 900;

  &:hover {
    background-color: var(--color-interaction-hover);
    color: var(--text-color-headline-invert);
  }
`;
